import React from "react";
import LicenseState from "license/LicenseState";
const StateCell = ({ violations, version = void 0, evaluated = true }) => /* @__PURE__ */ React.createElement(LicenseState, { violations, version, evaluated });
export default StateCell;
